import { useEffect } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { AppShell } from "./components/AppShell";
import Login from "./pages/Login";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminReports from "./pages/admin/AdminReports";
import AdminPayments from "./pages/admin/AdminPayments";
import AdminTours from "./pages/admin/AdminTours";
import AdminTeam from "./pages/admin/AdminTeam";
import AdminReviews from "./pages/admin/AdminReviews";
import AdminSchedule from "./pages/admin/AdminSchedule";
import AdminVendorIncome from "./pages/admin/AdminVendorIncome";
import DriverSchedule from "./pages/driver/DriverSchedule";
import DriverReviews from "./pages/driver/DriverReviews";
import SusukPage from "./pages/SusukPage";
import DriverHome from "./pages/driver/DriverHome";
import DriverPayments from "./pages/driver/DriverPayments";

const homeFor = (user) => (user.role === "admin" ? "/admin" : "/driver");

function Guard({ role, children }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen grid place-items-center" data-testid="auth-loading">
        <Loader2 className="h-6 w-6 animate-spin text-emerald-600" />
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (role && user.role !== role) return <Navigate to={homeFor(user)} replace />;
  return children;
}

function RootRedirect() {
  const { user } = useAuth();
  if (user === null) return null;
  return <Navigate to={user ? homeFor(user) : "/login"} replace />;
}

function App() {
  useEffect(() => { document.title = "Dewata Memories Tours | Driver Report"; }, []);
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/admin" element={<Guard role="admin"><AppShell role="admin" /></Guard>}>
            <Route index element={<AdminDashboard />} />
            <Route path="reports" element={<AdminReports />} />
            <Route path="payments" element={<AdminPayments />} />
            <Route path="tours" element={<AdminTours />} />
            <Route path="team" element={<AdminTeam />} />
            <Route path="reviews" element={<AdminReviews />} />
            <Route path="schedule" element={<AdminSchedule />} />
            <Route path="vendor-income" element={<AdminVendorIncome />} />
            <Route path="susuk" element={<SusukPage isAdmin />} />
          </Route>
          <Route path="/driver" element={<Guard role="team"><AppShell role="team" /></Guard>}>
            <Route index element={<DriverHome />} />
            <Route path="payments" element={<DriverPayments />} />
            <Route path="schedule" element={<DriverSchedule />} />
            <Route path="reviews" element={<DriverReviews />} />
            <Route path="susuk" element={<SusukPage isAdmin={false} />} />
          </Route>
          <Route path="*" element={<RootRedirect />} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-center" />
    </AuthProvider>
  );
}

export default App;
